import * as React from 'react'
import theme from 'common/utils/theme'

import { ReactComponent as ServicesIcon } from '../assets/tenders/servicesIcon.svg'
import { ReactComponent as SoftwareIcon } from '../assets/tenders/softwareIcon.svg'
import { ReactComponent as HardwareIcon } from '../assets/tenders/hardwareIcon.svg'

import { TopicType, UnitType } from './tenders.types'

export const getUnitName = (unitType: UnitType): string => {
  switch (unitType) {
    case UnitType.MAN_DAY:
      return 'Čovek/dan'
    case UnitType.MAN_HOUR:
      return 'Čovek/sat'
    case UnitType.ITEM:
      return 'Artikal'
    default:
      return ''
  }
}

export const getTopicIcon = (service: TopicType): JSX.Element => {
  switch (service) {
    case TopicType.SERVICE:
      return <ServicesIcon />
    case TopicType.SOFTWARE:
      return <SoftwareIcon />
    case TopicType.HARDWARE:
      return <HardwareIcon />
    default:
      return <></>
  }
}

export function getTopicLabel(type: TopicType): string {
  switch (type) {
    case TopicType.HARDWARE:
      return 'Hardver'
    case TopicType.SOFTWARE:
      return 'Softver'
    case TopicType.SERVICE:
      return 'Usluge'
    default:
      return '-'
  }
}

export function getTopicColor(type: TopicType): string {
  switch (type) {
    case TopicType.HARDWARE:
      return theme.palette.charts.indigo100.main
    case TopicType.SOFTWARE:
      return theme.palette.charts.green200.main
    default:
      return theme.palette.charts.orange400.main
  }
}
